import { Api as api } from "../../api";
const prefix = "/transport-resource";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    driverServiceV1GetDrivers: build.query<
      DriverServiceV1GetDriversApiResponse,
      DriverServiceV1GetDriversApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/drivers`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          search: queryArg.search,
          status: queryArg.status,
          sort_by: queryArg.sortBy,
          order: queryArg.order,
        },
      }),
      providesTags: [{ type: "Driver", id: "LIST" }],
    }),
    driverServiceV1BulkDeleteDriver: build.mutation<
      DriverServiceV1BulkDeleteDriverApiResponse,
      DriverServiceV1BulkDeleteDriverApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/drivers`,
        method: "DELETE",
        params: {
          ids: queryArg.ids,
          reason: queryArg.reason,
        },
      }),
    }),
    driverServiceV1CreateDriver: build.mutation<
      DriverServiceV1CreateDriverApiResponse,
      DriverServiceV1CreateDriverApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/drivers`,
        method: "POST",
        body: queryArg.transportResourceCreateDriverReq,
      }),
    }),
    driverServiceV1CreateDriverDraft: build.mutation<
      DriverServiceV1CreateDriverDraftApiResponse,
      DriverServiceV1CreateDriverDraftApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/drivers/draft`,
        method: "POST",
        body: queryArg.transportResourceCreateDriverDraftReq,
      }),
    }),
    driverServiceV1UpdateDriverDraft: build.mutation<
      DriverServiceV1UpdateDriverDraftApiResponse,
      DriverServiceV1UpdateDriverDraftApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/drivers/draft/${queryArg.id}`,
        method: "PUT",
        body: queryArg.driverServiceV1UpdateDriverDraftBody,
      }),
    }),
    driverServiceV1GetDriversByIDs: build.mutation<
      DriverServiceV1GetDriversByIDsApiResponse,
      DriverServiceV1GetDriversByIDsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/drivers/batch`,
        method: "POST",
        body: queryArg.transportResourceDriverIDs,
      }),
    }),
    driverServiceV1GetDriverDropdown: build.query<
      DriverServiceV1GetDriverDropdownApiResponse,
      DriverServiceV1GetDriverDropdownApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/drivers/dropdown`,
        params: {
          search: queryArg.search,
          exclude_assigned: queryArg.excludeAssigned,
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    driverServiceV1ExportDrivers: build.mutation<
      Blob,
      DriverServiceV1ExportDriversApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/drivers/export`,
        method: "POST",
        body: queryArg.transportResourceExportDriversReq,
        responseHandler: (response) =>
          response.ok ? response.blob() : response.json(),
      }),
    }),
    driverServiceV1ImportDriver: build.mutation<
      DriverServiceV1ImportDriverApiResponse,
      DriverServiceV1ImportDriverApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/drivers/import`,
        method: "POST",
        body: queryArg.apiHttpBody,
      }),
      invalidatesTags: [{ type: "Driver", id: "LIST" }],
    }),
    driverServiceV1DownloadDriverImportTemplate: build.query<
      DriverServiceV1DownloadDriverImportTemplateApiResponse,
      DriverServiceV1DownloadDriverImportTemplateApiArg
    >({
      query: () => ({ url: `${prefix}/v1/drivers/import/template` }),
    }),
    driverServiceV1BulkUpdateDriverStatus: build.mutation<
      DriverServiceV1BulkUpdateDriverStatusApiResponse,
      DriverServiceV1BulkUpdateDriverStatusApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/drivers/status`,
        method: "PATCH",
        body: queryArg.transportResourceBulkUpdateDriverStatusReq,
      }),
    }),
    driverServiceV1GetDriverDetail: build.query<
      DriverServiceV1GetDriverDetailApiResponse,
      DriverServiceV1GetDriverDetailApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/drivers/${queryArg.id}` }),
    }),
    driverServiceV1UpdateDriver: build.mutation<
      DriverServiceV1UpdateDriverApiResponse,
      DriverServiceV1UpdateDriverApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/drivers/${queryArg.id}`,
        method: "PUT",
        body: queryArg.driverServiceV1UpdateDriverBody,
      }),
    }),
    driverServiceV1GetDriverDocuments: build.query<
      DriverServiceV1GetDriverDocumentsApiResponse,
      DriverServiceV1GetDriverDocumentsApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/drivers/${queryArg.id}/documents` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as driverApi };
export type DriverServiceV1GetDriversApiResponse =
  /** status 200 A successful response. */ TransportResourceGetDriversRes;
export type DriverServiceV1GetDriversApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  sortBy?: string;
  order?: string;
};
export type DriverServiceV1BulkDeleteDriverApiResponse =
  /** status 200 A successful response. */ TransportResourceBulkDeleteDriverRes;
export type DriverServiceV1BulkDeleteDriverApiArg = {
  ids?: string[];
  reason?: string;
};
export type DriverServiceV1CreateDriverApiResponse =
  /** status 200 A successful response. */ TransportResourceCreateDriverRes;
export type DriverServiceV1CreateDriverApiArg = {
  transportResourceCreateDriverReq: TransportResourceCreateDriverReq;
};
export type DriverServiceV1CreateDriverDraftApiResponse =
  /** status 200 A successful response. */ TransportResourceCreateDriverDraftRes;
export type DriverServiceV1CreateDriverDraftApiArg = {
  transportResourceCreateDriverDraftReq: TransportResourceCreateDriverDraftReq;
};
export type DriverServiceV1UpdateDriverDraftApiResponse =
  /** status 200 A successful response. */ TransportResourceUpdateDriverDraftRes;
export type DriverServiceV1UpdateDriverDraftApiArg = {
  id: string;
  driverServiceV1UpdateDriverDraftBody: DriverServiceV1UpdateDriverDraftBody;
};
export type DriverServiceV1GetDriversByIDsApiResponse =
  /** status 200 A successful response. */ TransportResourceGetDriversRes;
export type DriverServiceV1GetDriversByIDsApiArg = {
  transportResourceDriverIDs: TransportResourceDriverIDs;
};
export type DriverServiceV1GetDriverDropdownApiResponse =
  /** status 200 A successful response. */ TransportResourceGetDriverDropdownRes;
export type DriverServiceV1GetDriverDropdownApiArg = {
  search?: string;
  excludeAssigned?: boolean;
  page?: number;
  limit?: number;
};
export type DriverServiceV1ExportDriversApiResponse =
  /** status 200 A successful response. */ ApiHttpBody;
export type DriverServiceV1ExportDriversApiArg = {
  transportResourceExportDriversReq: TransportResourceExportDriversReq;
};
export type DriverServiceV1ImportDriverApiResponse =
  /** status 200 Driver imported successfully */ TransportResourceImportDriverRes;
export type DriverServiceV1ImportDriverApiArg = {
  /** Message that represents an arbitrary HTTP body. It should only be used for
    payload formats that can't be represented as JSON, such as raw binary or
    an HTML page.
    
    
    This message can be used both in streaming and non-streaming API methods in
    the request as well as the response.
    
    It can be used as a top-level request field, which is convenient if one
    wants to extract parameters from either the URL or HTTP template into the
    request fields and also want access to the raw HTTP body.
    
    Example:
    
        message GetResourceRequest {
          // A unique request id.
          string request_id = 1;
    
          // The raw HTTP body is bound to this field.
          google.api.HttpBody http_body = 2;
    
        }
    
        service ResourceService {
          rpc GetResource(GetResourceRequest)
            returns (google.api.HttpBody);
          rpc UpdateResource(google.api.HttpBody)
            returns (google.protobuf.Empty);
    
        }
    
    Example with streaming methods:
    
        service CaldavService {
          rpc GetCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
          rpc UpdateCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
    
        }
    
    Use of this type only changes how the request and response bodies are
    handled, all other features will continue to work unchanged. */
  apiHttpBody: ApiHttpBody;
};
export type DriverServiceV1DownloadDriverImportTemplateApiResponse = unknown;
export type DriverServiceV1DownloadDriverImportTemplateApiArg = void;
export type DriverServiceV1BulkUpdateDriverStatusApiResponse =
  /** status 200 A successful response. */ TransportResourceBulkUpdateDriverStatusRes;
export type DriverServiceV1BulkUpdateDriverStatusApiArg = {
  transportResourceBulkUpdateDriverStatusReq: TransportResourceBulkUpdateDriverStatusReq;
};
export type DriverServiceV1GetDriverDetailApiResponse =
  /** status 200 A successful response. */ TransportResourceGetDriverDetailRes;
export type DriverServiceV1GetDriverDetailApiArg = {
  id: string;
};
export type DriverServiceV1UpdateDriverApiResponse =
  /** status 200 A successful response. */ TransportResourceUpdateDriverRes;
export type DriverServiceV1UpdateDriverApiArg = {
  id: string;
  driverServiceV1UpdateDriverBody: DriverServiceV1UpdateDriverBody;
};
export type DriverServiceV1GetDriverDocumentsApiResponse =
  /** status 200 A successful response. */ TransportResourceGetDriverDocumentsRes;
export type DriverServiceV1GetDriverDocumentsApiArg = {
  id: string;
};
export type TransportResourceDriverActor = {
  id?: string;
  name?: string;
  timestamp?: string;
};
export type TransportResourceDriverAffiliatedFleet = {
  id?: string;
  plate_number?: string;
};
export type TransportResourceDriverListItem = {
  id?: string;
  full_name?: string;
  phone_number?: string;
  email?: string;
  vendor_name?: string;
  license_type?: string;
  license_number?: string;
  status?: string;
  created_by?: TransportResourceDriverActor;
  updated_by?: TransportResourceDriverActor;
  vendor_code?: string;
  driver_picture_url?: string;
  affiliated_fleet?: TransportResourceDriverAffiliatedFleet;
};
export type TransportResourceDriverListMeta = {
  current_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
  limit?: number;
  total?: number;
  total_page?: number;
};
export type TransportResourceGetDriversRes = {
  driver?: TransportResourceDriverListItem[];
  metadata?: TransportResourceDriverListMeta;
};
export type ProtobufAny = {
  /** Identifies the type of the serialized Protobuf message with a URI reference
    consisting of a prefix ending in a slash and the fully-qualified type name.
    
    Example: type.googleapis.com/google.protobuf.StringValue
    
    This string must contain at least one `/` character, and the content after
    the last `/` must be the fully-qualified name of the type in canonical
    form, without a leading dot. Do not write a scheme on these URI references
    so that clients do not attempt to contact them.
    
    The prefix is arbitrary and Protobuf implementations are expected to
    simply strip off everything up to and including the last `/` to identify
    the type. `type.googleapis.com/` is a common default prefix that some
    legacy implementations require. This prefix does not indicate the origin of
    the type, and URIs containing it are not expected to respond to any
    requests.
    
    All type URL strings must be legal URI references with the additional
    restriction (for the text format) that the content of the reference
    must consist only of alphanumeric characters, percent-encoded escapes, and
    characters in the following set (not including the outer backticks):
    `/-.~_!$&()*+,;=`. Despite our allowing percent encodings, implementations
    should not unescape them to prevent confusion with existing parsers. For
    example, `type.googleapis.com%2FFoo` should be rejected.
    
    In the original design of `Any`, the possibility of launching a type
    resolution service at these type URLs was considered but Protobuf never
    implemented one and considers contacting these URLs to be problematic and
    a potential security issue. Do not attempt to contact type URLs. */
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type TransportResourceBulkDeleteDriverRes = {
  message?: string;
};
export type TransportResourceCreateDriverRes = {
  driver_id?: string;
  message?: string;
};
export type TransportResourceDriverDocument = {
  type: string;
  file_url: string;
};
export type TransportResourceCreateDriverReq = {
  full_name: string;
  ktp_number: string;
  phone_number: string;
  email: string;
  creation_method: string;
  password?: string;
  vendor_id: string;
  gender?: string;
  marital_status?: string;
  citizen_address?: string;
  domicile_address?: string;
  license_type: string;
  license_number: string;
  license_expiry_date: string;
  bank_name: string;
  bank_account_number: string;
  bank_account_holder: string;
  documents: TransportResourceDriverDocument[];
  driver_picture_url?: string;
  emergency_contact_name: string;
  emergency_contact_phone: string;
  emergency_contact_relation: string;
};
export type TransportResourceCreateDriverDraftRes = {
  driver_id?: string;
  message?: string;
};
export type TransportResourceCreateDriverDraftReq = {
  full_name?: string;
  ktp_number?: string;
  phone_number?: string;
  email?: string;
  creation_method?: string;
  password?: string;
  vendor_id?: string;
  gender?: string;
  marital_status?: string;
  citizen_address?: string;
  domicile_address?: string;
  license_type?: string;
  license_number?: string;
  license_expiry_date?: string;
  bank_name?: string;
  bank_account_number?: string;
  bank_account_holder?: string;
  documents?: TransportResourceDriverDocument[];
  driver_picture_url?: string;
  emergency_contact_name?: string;
  emergency_contact_phone?: string;
  emergency_contact_relation?: string;
};
export type TransportResourceUpdateDriverDraftRes = {
  driver_id?: string;
  message?: string;
};
export type DriverServiceV1UpdateDriverDraftBody = {
  full_name?: string;
  ktp_number?: string;
  phone_number?: string;
  email?: string;
  vendor_id?: string;
  gender?: string;
  marital_status?: string;
  citizen_address?: string;
  domicile_address?: string;
  license_type?: string;
  license_number?: string;
  license_expiry_date?: string;
  bank_name?: string;
  bank_account_number?: string;
  bank_account_holder?: string;
  documents?: TransportResourceDriverDocument[];
  driver_picture_url?: string;
  emergency_contact_name?: string;
  emergency_contact_phone?: string;
  emergency_contact_relation?: string;
};
export type TransportResourceDriverIDs = {
  ids?: string[];
};
export type TransportResourceDriverDropdownItem = {
  id?: string;
  full_name?: string;
};
export type TransportResourceDriverDropdownMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_page?: number;
  have_next_page?: boolean;
};
export type TransportResourceGetDriverDropdownRes = {
  drivers?: TransportResourceDriverDropdownItem[];
  metadata?: TransportResourceDriverDropdownMeta;
};
export type ApiHttpBody = {
  /** The HTTP Content-Type header value specifying the content type of the body. */
  contentType?: string;
  /** The HTTP request/response body as raw binary. */
  data?: string;
  /** Application specific response metadata. Must be set in the first response
    for streaming APIs. */
  extensions?: ProtobufAny[];
};
export type TransportResourceExportDriversReq = {
  format?: string;
  scope?: string;
  ids?: string[];
  search?: string;
  status?: string;
  sortBy?: string;
  order?: string;
};
export type TransportResourceImportDriverError = {
  row?: number;
  field?: string;
  message?: string;
};
export type TransportResourceImportDriverRes = {
  success?: boolean;
  imported_count?: number;
  message?: string;
  errors?: TransportResourceImportDriverError[];
};
export type TransportResourceBulkUpdateDriverStatusRes = {
  message?: string;
};
export type TransportResourceBulkUpdateDriverStatusReq = {
  ids?: string[];
  status?: string;
};
export type TransportResourceGetDriverDetailRes = {
  id?: string;
  driver_code?: string;
  join_date?: string;
  full_name?: string;
  ktp_number?: string;
  phone_number?: string;
  email?: string;
  vendor_id?: string;
  vendor_name?: string;
  gender?: string;
  marital_status?: string;
  citizen_address?: string;
  domicile_address?: string;
  license_type?: string;
  license_number?: string;
  license_expiry_date?: string;
  bank_name?: string;
  bank_account_number?: string;
  bank_account_holder?: string;
  status?: string;
  star_rating?: number;
  created_by?: TransportResourceDriverActor;
  updated_by?: TransportResourceDriverActor;
  emergency_contact_name?: string;
  emergency_contact_phone?: string;
  emergency_contact_relation?: string;
  driver_picture_url?: string;
};
export type TransportResourceUpdateDriverRes = {
  message?: string;
  success?: boolean;
};
export type DriverServiceV1UpdateDriverBody = {
  full_name: string;
  ktp_number: string;
  phone_number: string;
  email: string;
  vendor_id: string;
  gender?: string;
  marital_status?: string;
  citizen_address?: string;
  domicile_address?: string;
  license_type: string;
  license_number: string;
  license_expiry_date: string;
  bank_name: string;
  bank_account_number: string;
  bank_account_holder: string;
  documents: TransportResourceDriverDocument[];
  driver_picture_url?: string;
  status?: string;
  emergency_contact_name: string;
  emergency_contact_phone: string;
  emergency_contact_relation: string;
};
export type TransportResourceDriverDocumentItem = {
  id?: string;
  type?: string;
  file_url?: string;
  created_at?: string;
};
export type TransportResourceGetDriverDocumentsRes = {
  documents?: TransportResourceDriverDocumentItem[];
};
export const {
  useDriverServiceV1GetDriversQuery,
  useDriverServiceV1BulkDeleteDriverMutation,
  useDriverServiceV1CreateDriverMutation,
  useDriverServiceV1CreateDriverDraftMutation,
  useDriverServiceV1UpdateDriverDraftMutation,
  useDriverServiceV1GetDriversByIDsMutation,
  useDriverServiceV1GetDriverDropdownQuery,
  useDriverServiceV1ExportDriversMutation,
  useDriverServiceV1ImportDriverMutation,
  useDriverServiceV1DownloadDriverImportTemplateQuery,
  useDriverServiceV1BulkUpdateDriverStatusMutation,
  useDriverServiceV1GetDriverDetailQuery,
  useDriverServiceV1UpdateDriverMutation,
  useDriverServiceV1GetDriverDocumentsQuery,
} = injectedRtkApi;
